import {Map, List, fromJS} from 'immutable';

function setState(state, newState) {
  return state.merge(newState);
}

function createRecord(state, action) {
  let newState = state;
  if(state.get(action.node) === undefined) {
    newState = newState.set(action.node, List.of());
  }
  const newRecord = fromJS(action.attributes);
  return newState.set(action.node, newState.get(action.node).push(newRecord));
}

function createFiles(state, action) {
  let newState = state;
  if(state.get('files') === undefined) {
    return newState.set('files', fromJS(action.files));
  } else {
    action.files.map(file => {
      const matchIndex = state.get('files').findIndex(f => f.get('name') === file.name);
      if(matchIndex > -1) {
        newState = newState.setIn(['files', matchIndex], fromJS(file));
      } else {
        newState = newState.update('files', (files) => files.push(fromJS(file)));
      }
    });
    return newState.set('loading', false);
  }
}

function updateRecord(state, action) {
  const index = state.get(action.node).findIndex(
      record => record.get('id') === action.id
  );
  if (action.value === '') {
    return state.deleteIn([action.node, index, action.attribute]);
  } else {
    return state.setIn([action.node, index, action.attribute], action.value);
  }
}

function updateRecords(state, action) {
  if (state.get(action.node) !== []) {
    let newState = state;
    action.updates.map((item) => {
      item['node'] = action.node;
      newState = updateRecord(newState, item);
    });
    return newState;
  } else {
    return state;
  }
}

function destroyRecord(state, action) {
  if (state.get(action.node) !== []) {
    return state.set(action.node, state.get(action.node).filter(function(item) {
      return item.get('id') !== action.id;
    }));
  } else {
    return state;
  }
}

function destroyRecords(state, action) {
  if (state.get(action.node) !== []) {
    return state.set(action.node, state.get(action.node).filter(function(item) {
      return action.ids.indexOf(item.get('id')) === -1;
    }));
  } else {
    return state;
  }
}

function updateSettings(state, action) {
  let newState = state;
  for (var property in action) {
    if (action.hasOwnProperty(property)) {
      newState = newState.setIn(['settings', property], action[property]);
    }
  }
  return newState;
}

function subjectsUpdate(state, action) {
  return state.set('subjects', fromJS(action));
}

function projectUpdate(state, action) {
  return state.set(action.attribute, action.value);
}

function setStatistics(state, action) {
  return state.withMutations(context => {
     context.set('statistics', fromJS(action.statistics)).set('filename', fromJS(action.filename));
  });
}

function setLoading(state, action) {
  return state.withMutations((ctx) => {
    ctx.set('loading', action.loading).set('loadingMessage', action.message)
  });
}

export default function(state = Map(), action) {
  switch(action.type) {
  case 'SET_STATE':
    return setState(state, action.state);
  case 'RECORD_CREATE':
    return createRecord(state, action.state);
  case 'RECORD_UPDATE':
    return updateRecord(state, action.state);
  case 'RECORDS_UPDATE':
    return updateRecords(state, action.state);
  case 'RECORD_DESTROY':
    return destroyRecord(state, action.state);
  case 'RECORDS_DESTROY':
    return destroyRecords(state, action.state);
  case 'SETTINGS_UPDATE':
    return updateSettings(state, action.state);
  case 'SUBJECTS_UPDATE':
    return subjectsUpdate(state, action.state.subjects);
  case 'PROJECT_UPDATE':
    return projectUpdate(state, action.state);
  case 'SET_STATISTICS':
    return setStatistics(state, action.state);
  case 'FILES_CREATE':
    return createFiles(state, action.state);
  case 'SET_LOADING':
    return setLoading(state, action.state);
  }
  return state;
}
